import type { FilePart } from "@openanalyst-ai/sdk/v2"

export function attached(part: FilePart) {
  return part.url.startsWith("data:")
}

export function inline(part: FilePart) {
  if (attached(part)) return false
  return part.source?.text?.start !== undefined && part.source?.text?.end !== undefined
}

export function kind(part: FilePart) {
  if (part.mime.startsWith("image/")) return "image"
  if (part.mime.startsWith("video/")) return "video"
  return "file"
}

export function videoProps(part: FilePart, label: string) {
  return {
    src: part.url,
    controls: true,
    preload: "metadata" as const,
    "aria-label": label,
  }
}
